import { useState } from "react";
import {
  Card,
  CardContent,
} from "../../ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../ui/table";
import { Badge } from "../../ui/badge";
import { Input } from "../../ui/input";
// import { FilterDropdown } from "../../ui/filter-dropdown";
/* import { ArrowUpIcon, ArrowDownIcon } from "lucide-react"; */
import { SummaryHeader } from "../../ui/SummaryHeader";
import MarketingLoader from "../../../components/loaders/MarketingLoader";
import { useMarketingEcomm } from "../../e-commerce/hooks/useMarketingEcomm";
import { formatCurrency } from "../../../utils/formatCurrency";

export function RetailCampaignPerformance({
  month = "2025-04",
  limit = 40,
}: {
  month?: string;
  limit?: number;
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const { data, isLoading } = useMarketingEcomm(month, limit);


  type CampaignPerformanceItem = {
  campaign: string;
  type: string;
  channel: string;
  spend: number;
  total_revenue: number;
  total_orders: number;
  refunded: number;
  net_revenue: number;
  roas: number;
};

  const campaignData: CampaignPerformanceItem[] = data?.campaign_performance ?? [];

const filteredData = campaignData.filter((campaign) =>
  campaign.campaign.toLowerCase().includes(searchTerm.toLowerCase())
);

  return (
    <>
      <SummaryHeader
        title="Campaign Performance"
      />
      <Card className="col-span-full">
        <CardContent className="px-3">
          <div className="flex flex-col sm:flex-row gap-4 mb-6">
            <Input
              placeholder="Search campaigns..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="max-w-sm"
            />

            {/* These filters are disabled since your data doesn’t include variety yet */}
            {/* <FilterDropdown ...typeOptions /> */}
            {/* <FilterDropdown ...channelOptions /> */}
          </div>

          {isLoading ? (
            <MarketingLoader variant="campaign-tbl" itemCount={1} />
          ) : (
            <div className="rounded-md border w-full overflow-x-visible">
      <Table className="table-auto w-full">
                <TableHeader>
                  <TableRow>
                    <TableHead>Campaign</TableHead>
                    <TableHead>Type</TableHead>
                    <TableHead>Channel</TableHead>
                    <TableHead>Orders</TableHead>
                    <TableHead>Spend</TableHead>
                    <TableHead>Revenue</TableHead>
                    <TableHead>ROAS</TableHead>
                    <TableHead>Refunded</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {filteredData.map((campaign) => (
                    <TableRow key={campaign.campaign}>
                      <TableCell className="text-sm">
                        {campaign.campaign}
                      </TableCell>
                      <TableCell className="text-sm">
                        <Badge
                          variant="outline"
                          className="bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300"
                        >
                          {campaign.type}
                        </Badge>
                      </TableCell>
                      <TableCell className="text-sm">{campaign.channel}</TableCell>
                      <TableCell className="text-sm">{campaign.total_orders}</TableCell>
                      <TableCell className="text-sm">{formatCurrency(campaign.spend)}</TableCell>
                      <TableCell className="text-sm">{formatCurrency(campaign.total_revenue)}</TableCell>
                      <TableCell className={getROASClass(campaign.roas)}>
                        {campaign.roas.toFixed(2)}x
                      </TableCell>
                      <TableCell>${campaign.refunded.toFixed(2)}</TableCell>
                    </TableRow>
                  ))}

                  {filteredData.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={8} className="h-24 text-center">
                        No campaigns found.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          )}
        </CardContent>
      </Card>
    </>
  );
}

function getROASClass(roas: number) {
  if (roas >= 5) return "text-green-600 dark:text-green-400 font-medium";
  if (roas >= 3) return "text-emerald-600 dark:text-emerald-400";
  if (roas >= 1) return "text-amber-600 dark:text-amber-400";
  return "text-red-600 dark:text-red-400";
}
